const genericFields = `
  id
  area {
    value
    units
  }
  leased
  floor
  floors
  city {
    id
    name
  }
  location {
    id
    name
    fullName
  }
  hasMortgage
  price {
    value
    currency
  }
  company {
    id
    name
    targetType
  }
  paidDaily
  rooms
  hasBillOfSale
  hasRepair
  vipped
  featured
  updatedAt
  path
  photosCount
`;

export default genericFields;
